import { constants as config } from '@config';
import Store, { actions } from '@store';

const CompanyFactory = require('./company').instance;
const DesygnerApiFactory = require('./desygner-api');

const HAS_PLACEHOLDERS = 'has_placeholders';
const placeholders = require('../ui/tool-menu/placeholders/placeholders.json');

function PlaceholdersFactory () {
  this.hasAutomationTemplates = false;
}

PlaceholdersFactory.prototype.init = function (opts) {
  opts = opts || {};

  CompanyFactory.getCompanyData().then(data => {
    const {
      metadata,
      features
    } = data || {};
    const customPlaceholders = (metadata && metadata.placeholders) || {};

    this.hasAutomationTemplates = features?.white_label?.includes('automation_in_templates');

    this.companyId = data.id;

    this.getSmartAssets().then(userInputs => {
      this.setSmartAssets(userInputs);

      typeof opts.callback === 'function' && opts.callback({
        // TODO remove
        customPlaceholders: this.hasAutomationTemplates && customPlaceholders,
        userInputs: this.userInputs,
        hasAutomationTemplates: this.hasAutomationTemplates
      });
    });

    this.hasAutomationTemplates && CompanyFactory.getProjectData().then((projectData) => {
      this.hasPlaceholdersInUse = projectData[HAS_PLACEHOLDERS];
      this.upToDate = true;

      this.initialSaveValues = {
        ...this.initialSaveValues || {},
        // TODO remove
        //customPlaceholders: this.customPlaceholders,
        hasPlaceholdersInUse: this.hasPlaceholdersInUse,
        upToDate: true
      };

      this.companyId = projectData.company.id;
      this.templateId = projectData.id;
      this.formatId = projectData.format;

      INKIVE.ImagesFactory.addBBoxValues();
    });
  });

  this.initListeners(opts);
};

PlaceholdersFactory.prototype.initListeners = function (opts) {
  INKIVE.DesignFacade.on('delete', this.updateHasPlaceholders.bind(this));
  INKIVE.History.on('undo', _.debounce(this.updateHasPlaceholders.bind(this), 500));
  INKIVE.History.on('redo', _.debounce(this.updateHasPlaceholders.bind(this), 500));
};

PlaceholdersFactory.prototype.updateHasPlaceholders = function (opts) {
  const attr = config.smartAssets.attributes.userInput;
  const placeholdersInUse = document.querySelectorAll(`#svgcontent [${attr}]`);
  const hasPlaceHoldersInUse = placeholdersInUse.length > 0;

  if (this.hasPlaceholdersInUse !== undefined && hasPlaceHoldersInUse !== this.hasPlaceholdersInUse) {
    this.hasPlaceholdersInUse = hasPlaceHoldersInUse;
    this.upToDate = false;

    INKIVE.DesignFacade.trigger('placeholder.update');
  }
};

PlaceholdersFactory.prototype.haveChanged = function () {
  return this.hasAutomationTemplates &&
    (this.initialSaveValues.hasPlaceholdersInUse !== this.hasPlaceholdersInUse ||
      this.initialSaveValues.upToDate !== this.upToDate);
};

PlaceholdersFactory.prototype.save = function (opts) {
  opts = opts || {};

  return new Promise((resolve) => {
    const url = `brand/companies/${this.companyId}/templates/${this.templateId}`;

    DesygnerApiFactory.get(url).then((data) => {
      data.smart_assets = this.getSmartAssetsInUse();

      if (opts.undraft) data.is_draft = false;

      DesygnerApiFactory.put(url, data).then(() => {
        this.initialSaveValues.hasPlaceholdersInUse = this.hasPlaceholdersInUse;
        this.initialSaveValues.upToDate = true;
        resolve();
      });
    });
  });
};

PlaceholdersFactory.prototype.getPlaceholdersInUse = function () {
  const {
    userInput: userInputsAttr,
    definedAsset: definedAssetAttr
  } = config.smartAssets.attributes;

  return Array.from($(`#svgcontent [${userInputsAttr}]`))
    .map(element => element.getAttribute(userInputsAttr).split(','))
    .flat()
    .filter((value, index, self) =>
      value &&
      isUnique(value, index, self) &&
      isCustom(value)
    );

  function isUnique (value, index, self) {
    return self.indexOf(value) === index;
  }

  function isCustom (placeholder) {
    for (const type in placeholders) {
      for (const i in placeholders[type]) {
        if (placeholders[type][i].data.indexOf(placeholder) > -1) {
          return false;
        }
      }
    }

    return true;
  }
};

PlaceholdersFactory.prototype.getSmartAssetsInUse = function () {
  const placeholdersInUse = this.getPlaceholdersInUse();

  const findSmartAssetInUse = asset => {
    return placeholdersInUse.find(placeholder => placeholder === asset.value);
  };

  return Object.entries(this.initialSaveValues.userInputs || {})
    .reduce((userInputs, [type, data]) => {
      const userInputsInUse = data.filter(findSmartAssetInUse);

      if (!userInputsInUse.length) return userInputs;

      return {
        ...userInputs,
        [type]: userInputsInUse
      };
    }, {});
};

PlaceholdersFactory.prototype.getSmartAssets = function () {
  const { types } = config.smartAssets;

  return Promise.all(types.map(this.fetchSmartAsset.bind(this)))
    .then(result => {
      return result
        .filter(response => response && Array.isArray(response.data));
    });
};

PlaceholdersFactory.prototype.fetchSmartAsset = function (type) {
  return new Promise((resolve) => {
    const url = `brand/companies/${this.companyId}/assets/${type}?user_input=true`;

    DesygnerApiFactory.get(url)
      .then(data => {
        data = Array.isArray(data) ? data : [];
        Store.dispatch(actions.assets.setUserInputs(data));

        return resolve({ type, data });
      }, resolve);
  });
};

PlaceholdersFactory.prototype.setSmartAssets = function (userInputs) {
  return userInputs.forEach(({ type, data }) => this.setSmartAsset(type, data));
};

PlaceholdersFactory.prototype.setSmartAsset = function (type, data) {
  this.userInputs = this.userInputs || {};

  formatData(this.userInputs, data);

  this.initialSaveValues = {
    ...this.initialSaveValues || {},
    userInputs: this.userInputs
  };

  function formatData (userInputs, data) {
    data.forEach(item => {
      const type = item.type.toLocaleLowerCase();
      userInputs[type] = userInputs[type] || [];
      userInputs[type].push({
        ...item,
        value: item.id,
        placeholder_name: INKIVE.Helpers.slugify(item.smart_asset?.user_input?.name || ''),
        name: item.smart_asset?.user_input?.name
      });
    });
  }
};

module.exports = new PlaceholdersFactory();
